import {Injectable} from '@angular/core';
import {DimensionItem, DimensionLevel, Perspective} from '@selpia/shared/models';

@Injectable({
  providedIn: 'root'
})
export abstract class DimensionLevelService {
  abstract getDimensionLevel(dimensionItem: DimensionItem, perspective: Perspective | undefined): DimensionLevel | undefined;
}
